export const GET_SUPERVISOR_GROUPS = 'GET_SUPERVISOR_GROUPS'
export const GET_AVAILABLE_USERS = 'GET_AVAILABLE_USERS'
